var map = {
	"./404-2.png": 11441,
	"./android.svg": 66926,
	"./androidicon.svg": 35117,
	"./apilink.svg": 70567,
	"./appleicon.svg": 41364,
	"./arrow-sidebar-hover.svg": 34490,
	"./arrow-sidebar.svg": 85459,
	"./bg-mast-head.svg": 48133,
	"./blog1.png": 3589,
	"./blog2.png": 49582,
	"./blog3.png": 78807,
	"./blog4.png": 46168,
	"./blog5.png": 67297,
	"./blog6.png": 36714,
	"./blogpost.png": 36680,
	"./cancel.svg": 69799,
	"./card-1.svg": 44433,
	"./card-2.svg": 73538,
	"./card-3.svg": 52531,
	"./card-4.svg": 68492,
	"./card-5.svg": 48205,
	"./card-6.svg": 19086,
	"./card-7.png": 34224,
	"./card-8.svg": 37304,
	"./card-9.png": 41742,
	"./copybutton.svg": 8630,
	"./createreserved.png": 57150,
	"./ddebit1.png": 41563,
	"./ddebit2.png": 63232,
	"./demo.svg": 94480,
	"./directdebit.png": 26919,
	"./existingaccount.png": 96964,
	"./facebook.svg": 83925,
	"./favicon.png": 54472,
	"./flutter.svg": 12177,
	"./fluttericon.svg": 17134,
	"./getinfo.svg": 27295,
	"./githublogo.png": 37802,
	"./hamburger.svg": 55942,
	"./icon-0.svg": 41293,
	"./icon-1.svg": 42348,
	"./icon-10.svg": 90260,
	"./icon-11.svg": 35189,
	"./icon-12.png": 84881,
	"./icon-2.svg": 21375,
	"./icon-3.svg": 92942,
	"./icon-4.svg": 91441,
	"./icon-5.svg": 55488,
	"./icon-6.svg": 76243,
	"./icon-7.svg": 71074,
	"./icon-8.svg": 15717,
	"./icon-9.svg": 64548,
	"./icon.png": 68689,
	"./image 1.jpeg": 92367,
	"./image 2.jpeg": 95218,
	"./image 3.jpeg": 36793,
	"./image 4.jpeg": 5772,
	"./image-147.png": 46546,
	"./image-153.png": 91705,
	"./image-169.png": 73922,
	"./image-600.png": 53118,
	"./image-66.png": 79794,
	"./image-670.png": 31507,
	"./image-808.png": 19624,
	"./image-906.png": 32375,
	"./image-9090.png": 73746,
	"./instagram.svg": 51359,
	"./ios.svg": 35912,
	"./iossdk.jpeg": 78076,
	"./landing-page-image.png": 61101,
	"./learnmore.svg": 53038,
	"./logo.png": 94971,
	"./logo.svg": 66748,
	"./malert.svg": 73152,
	"./monnify-dev-2.svg": 80802,
	"./monnify-logo.png": 82452,
	"./monnify-logo.svg": 76819,
	"./monnifyLogo.png": 33983,
	"./monnifyLogo.svg": 62256,
	"./monnifystatus.svg": 18771,
	"./newaccount.png": 72757,
	"./offline-collection-flow.png": 55331,
	"./paymentlink1.png": 33053,
	"./paymentlink2.png": 49286,
	"./paymentlink3.png": 34383,
	"./paymentlink4.png": 22160,
	"./recurring-payments.png": 29109,
	"./reference.svg": 40240,
	"./refund-monnify-dashboard.png": 30094,
	"./refunds.png": 89189,
	"./santa4d57063c84061a.png": 96323,
	"./search.svg": 93489,
	"./searchicon.svg": 66830,
	"./slack-logo2.svg": 52085,
	"./slack.svg": 20975,
	"./sub-account1.png": 16263,
	"./sub-account2.png": 97260,
	"./test-image.png": 42014,
	"./transferLogo.png": 56298,
	"./transferLogo.svg": 22309,
	"./twitter.svg": 68802,
	"./ui-transfers-2.png": 14062,
	"./ui-transfers.png": 25667,
	"./video.svg": 44722,
	"./view-arrow.svg": 33998,
	"./viewmore.svg": 85869,
	"./walert.svg": 43758,
	"./web.svg": 98513,
	"./webhook-page.png": 52983,
	"./websdk-sample.png": 19921,
	"./websdk-sample2.png": 88695,
	"./worldicon.svg": 99084,
	"./youtubeplay.svg": 24758
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;